import styled from '@emotion/styled';

export const TrackedProgress = styled.div`
  flex-grow: 1;

  margin-right: 5px;
  padding-right: 5px;
  border-radius: 3px;
  width: ${({ isMobile }) => (isMobile ? '95%' : null)};
`;

export const ProgressBar = styled.div`
  display: flex;
  height: ${({ size }) => (size === 'small' ? '4px' : '8px')};
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
`;

export const TotalTrackedTime = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  line-height: 15px;
  margin-left: 3px;
  color: ${({ theme }) => theme.colors.primary};
`;

export const AvatarsGroup = styled.div`
  display: flex;
  min-height: 22px;
`;

export const UserAvatar = styled.div`
  &:hover {
    cursor: pointer;
  }
`;

export const Tooltip = styled.div`
  display: flex;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MarginLeft = styled.div`
  margin-left: 4px;
`;

export const TooltipText = styled.div`
  display: flex;
`;

export const Story = styled.div`
  display: flex;
`;
